module.exports = __webpack_public_path__ + "img/23_24.44617efc.png";